import React from 'react'
import Button from 'shared/ui/Button/Button'
import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg'
import ContentFiltersPanel from 'widgets/FiltersPanel/components/ContentFiltersPanel/ContentFiltersPanel'
import DropdownFilter from 'widgets/FiltersPanel/components/DropdownFilter/DropdownFilter'
import s from './styles/FiltersContent.module.scss'

export const FiltersContent = ({
	students,
	counselors,
	selected,
	onChangeKey,
	onApply,
	onClose,
}) => {
	const gradeValues = Array.from(
		new Set(
			students
				.map(row => String(row.grade || '').trim())
				.filter(Boolean),
		),
	).sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true }))

	const gradeOptions = gradeValues.map(value => ({
		value,
		label: value.toLowerCase().startsWith('grade') ? value : `Grade ${value}`,
		count: students.filter(row => String(row.grade) === value).length,
	}))

	const planOptions = ['Essential', 'Premium'].map(value => ({
		value,
		label: value,
		count: students.filter(row => row.plan === value).length,
	}))

	const counselorOptions = [
		{
			value: 'Unassigned',
			label: 'Unassigned',
			count: students.filter(row => row.counselor === 'Unassigned').length,
		},
		...counselors.map(item => ({
			value: item.name,
			label: item.name,
			count: students.filter(row => row.counselor === item.name).length,
		})),
	]

	const assignmentOptions = [
		{
			value: 'assigned',
			label: 'Has assignments',
			count: students.filter(row => row.assignments > 0).length,
		},
		{
			value: 'none',
			label: 'None',
			count: students.filter(row => !row.assignments).length,
		},
	]

	const filtersConfig = [
		{ key: 'grade', title: 'Grade', options: gradeOptions },
		{ key: 'plan', title: 'Kandor plan', options: planOptions },
		{ key: 'counselor', title: 'Counsellor', options: counselorOptions },
		{ key: 'assignments', title: 'Assignments', options: assignmentOptions },
	]

	return (
		<ContentFiltersPanel
			title="Filters"
			subtitle="Select multiple filters"
			icon={<FilterIcon />}
			onClose={onClose}
		>
			<div className={s.section}>
				{filtersConfig.map(item => (
					<DropdownFilter
						key={item.key}
						filterKey={item.key}
						title={item.title}
						options={item.options}
						selected={selected[item.key] || []}
						onChangeKey={onChangeKey}
					/>
				))}
			</div>
			<Button onClick={onApply}>Search</Button>
		</ContentFiltersPanel>
	)
}

export default FiltersContent
